import { atom } from 'jotai';
import { nanoid } from 'nanoid';

/**
 *  Jotai used to track ALL DialogDrawer open states.
 *  Useful to ensure Dialogs and Dropdown's aren't open at the same time
 */

type DialogDrawerState = {
  id: string;
  open: boolean;
};

const dialogDrawerStatesAtom = atom<DialogDrawerState[]>([]);

export const anyDialogDrawerOpenAtom = atom((get) => {
  const states = get(dialogDrawerStatesAtom);
  return states.some((s) => s.open);
});

export const registerDialogDrawer = atom(null, (_, set) => {
  const id = nanoid();
  set(dialogDrawerStatesAtom, (prev) => {
    return [...prev, { id, open: false }];
  });
  return id;
});

export const unregisterDialogDrawer = atom(null, (_, set, id: string) => {
  set(dialogDrawerStatesAtom, (states) => {
    return states.filter((state) => state.id !== id);
  });
});

export const trackDialogDrawerOpen = atom(null, (_, set, id: string, open: boolean) => {
  set(dialogDrawerStatesAtom, (states) => {
    return states.map((state) => {
      if (state.id === id) {
        return { ...state, open };
      }
      return state;
    });
  });
});
